var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-100 mx-auto mx-lg-0"},[_c('div',{staticClass:"page-title-box d-flex align-items-center justify-content-center align-items-lg-start"},[_c('h4',{staticClass:"my-1 font-size-18"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }